import { sanitizeStudentGalleryName, sanitizeGalleryFilename } from './studentGallery';
import { getStudentSignaturesBucketName } from './supabase';

export { sanitizeStudentGalleryName as sanitizeStudentSignatureName };

/** Storage object key: [studentName]_[fileName] */
export function buildStudentSignatureStoragePath(studentName, fileName) {
  const safeName = sanitizeStudentGalleryName(studentName);
  const safeFile = sanitizeGalleryFilename(fileName);
  return `${safeName}_${safeFile}`;
}

export function signatureStorageKeyForStudentName(studentName) {
  return sanitizeStudentGalleryName(studentName).toLowerCase();
}

export async function listStudentSignatureUrlsByKey(supabase) {
  const bucket = getStudentSignaturesBucketName();
  const { data, error } = await supabase.storage.from(bucket).list('', {
    limit: 500,
    sortBy: { column: 'created_at', order: 'desc' },
  });
  if (error) {
    throw new Error(error.message || 'Could not list student signatures');
  }
  const map = {};
  for (const item of data || []) {
    if (!item?.name) continue;
    const underscore = item.name.indexOf('_');
    if (underscore <= 0) continue;
    const key = item.name.slice(0, underscore).toLowerCase();
    if (map[key]) continue;
    const { data: pub } = supabase.storage.from(bucket).getPublicUrl(item.name);
    if (pub?.publicUrl) {
      map[key] = pub.publicUrl;
    }
  }
  return map;
}

export function resolveSignatureUrlForStudentName(signatureUrlByKey, studentName) {
  if (!signatureUrlByKey || !studentName) return null;
  const key = signatureStorageKeyForStudentName(studentName);
  return signatureUrlByKey[key] || null;
}

export async function uploadStudentSignatureImage(
  supabase,
  studentName,
  { uri, fileName, uriToArrayBuffer, guessMimeFromName }
) {
  const bucket = getStudentSignaturesBucketName();
  const path = buildStudentSignatureStoragePath(studentName, fileName);
  const body = await uriToArrayBuffer(uri);
  const { error } = await supabase.storage.from(bucket).upload(path, body, {
    contentType: guessMimeFromName(fileName),
    upsert: true,
  });
  if (error) {
    throw new Error(error.message || 'Signature upload failed');
  }
  const { data: pub } = supabase.storage.from(bucket).getPublicUrl(path);
  const publicUrl = pub?.publicUrl;
  if (!publicUrl) {
    throw new Error('Could not get public URL for signature image');
  }
  return { path, url: publicUrl };
}
